import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import { Menu } from '../Menu/Menu';
import { SearchFieldSuggestionItemRow } from './Components/SearchFieldSuggestionItemRow';
import { SearchFieldSuggestionItem } from './Models/SearchFieldSuggestionItem';
import { SearchFieldProps } from './SearchFieldProps';

export const SearchField: FunctionComponent<SearchFieldProps> = ({
  className,
  placeholder,
  value,
  menu,
  suggestions,
  onSearch
}) => {
  function searchDidChange(event: React.ChangeEvent<HTMLInputElement>): void {
    onSearch(event.target.value);
  }

  function didSelectItem(item: SearchFieldSuggestionItem): void {
    suggestions?.onSelection(item.id);
  }

  return (
    <div className="relative">
      <div className="h-stack rounded-lg border border-black border-opacity-10 divide-x">
        <div className="w-full pl-2 h-stack items-center space-x-1">
          <img className="w-4 h-4 opacity-50" src="/images/icons/search_black.svg" />
          <input
            className={classNames('w-full pr-3 py-1 bg-transparent border-none', className)}
            placeholder={placeholder ?? 'Search'}
            value={value}
            onChange={searchDidChange}
          />
        </div>

        {menu ? (
          <Menu {...menu} className="bg-transparent border-t-0 border-b-0 border-r-0 border-black border-opacity-10" />
        ) : undefined}
      </div>

      {suggestions && suggestions.items.length > 0 && (value ?? '').length > 0 ? (
        <div className="absolute top-12 left-0 z-10 w-full h-60 bg-bg rounded-lg border border-black border-opacity-5 shadow-lg overflow-y-auto">
          <div className="v-stack divide-y">
            {suggestions.items.map((item) => (
              <SearchFieldSuggestionItemRow key={item.id} item={item} onSelection={(): void => didSelectItem(item)} />
            ))}
          </div>
        </div>
      ) : undefined}
    </div>
  );
};
